import { Component } from '@angular/core';

@Component({
    selector: 'tlf-options-menu',
    templateUrl: './options-menu.component.html',
    styleUrls: ['./options-menu.component.css'],
})
export class OptionsMenuComponent {
    constructor() { }
}
